import { createSlice } from '@reduxjs/toolkit';
import { getScheduledActivityListQuery } from './thunk';

const initialState = {
	data: [],
	isListLoading: false,
	isListLoaded: false,
	error: null,
};

const ScheduledActivitySlice = createSlice({
	name: 'ScheduledActivity',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(getScheduledActivityListQuery.pending, state => {
				state.isListLoading = true;
				state.isListLoaded = false;
				state.error = null;
			})
			.addCase(getScheduledActivityListQuery.fulfilled, (state, action) => {
				state.isListLoading = false;
				state.isListLoaded = true;
				state.data = action.payload?.data || action.payload || [];
			})
			.addCase(getScheduledActivityListQuery.rejected, (state, action) => {
				state.isListLoading = false;
				state.error = action.error.message;
			});
	},
});

export default ScheduledActivitySlice.reducer;
